module.exports = __webpack_public_path__ + "img/external_api.f2a0e9d4.png";